import React, { useEffect, useState } from 'react'
import { Container, Spinner, Table } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

function PrintReportDetailAbsenKaryawanInti ()
{

    const location = useLocation();
    const { dataTable } = location.state;
    const { user_name } = location.state;

    const [ done, setDone ] = useState( false );
    const navigate = useNavigate();


    useEffect( () =>
    {
        const timer = setTimeout( () =>
        {
            setDone( true );
        }, 2000 );

        return () => clearTimeout( timer );
    }, [] );

    useEffect( () =>
    {
        if ( done ) {
            window.print();
        }
    }, [ done ] );

    useEffect( () =>
    {
        const handleAfterPrint = () =>
        {
            navigate( -1 );
        };

        window.addEventListener( 'afterprint', handleAfterPrint );

        return () =>
        {
            window.removeEventListener( 'afterprint', handleAfterPrint );
        };
    }, [ navigate ] );

    return (
        <Container fluid style={ { minHeight: '100vh', overflowX: 'hidden' } }>
            <div className='text-start'>
                <h1 className='mt-2' style={ { fontFamily: 'Poppins-Regular' } }>Report Absen Detail : { user_name } </h1>
            </div>
            { !done ? (
                <Container className='text-center mb-3'>
                    <div className='my-5'>
                        <Spinner animation="border" size='lg' style={ customSpinnerStyle } />
                    </div>
                </Container>
            ) : (
                <>
                    <div className='mt-3'>
                        <Table responsive >
                            <thead style={ { fontFamily: 'Poppins-Regular' } }>
                                <tr>
                                    <th>#</th>
                                    <th>Tanggal Masuk</th>
                                    <th>Tanggal Pulang</th>
                                    <th>Jam Masuk</th>
                                    <th>Jam Pulang</th>
                                    <th>Keterlambatan</th>
                                    <th>Pulang Awal</th>
                                    <th>Lembur</th>
                                </tr>
                            </thead>
                            <tbody style={ { fontFamily: 'Poppins-Light' } }>
                                {
                                    dataTable?.map( ( data, index ) =>
                                    {
                                        return (

                                            <tr key={ index }>
                                                <td>{ index + 1 }</td>
                                                <td>{ data?.checkin_time ? data?.checkin_time.split( 'T' )[ 0 ] : '' }</td>
                                                <td>{ data?.checkout_time ? data?.checkout_time.split( 'T' )[ 0 ] : '' }</td>
                                                <td>{ data?.checkin_time ? data?.checkin_time.split( 'T' )[ 1 ].split( '.' )[ 0 ] : '' }</td>
                                                <td>{ data?.checkout_time ? data?.checkout_time.split( 'T' )[ 1 ].split( '.' )[ 0 ] : '' }</td>
                                                <td>{ data?.late_duration }</td>
                                                <td>{ data?.early_duration }</td>
                                                <td>{ data?.overtime_duration }</td>
                                            </tr>

                                        )
                                    } )
                                }
                            </tbody>
                        </Table>
                    </div>
                </>
            ) }
        </Container>
    )
}

export default PrintReportDetailAbsenKaryawanInti;

const customSpinnerStyle = {
    color: '#000A2E',
};